import React, { CSSProperties } from "react";
import cn from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsSpin } from "@fortawesome/free-solid-svg-icons";
import { twMerge } from "tailwind-merge";

type Props = {
  disabled?: boolean;
  label?: string | JSX.Element;
  className?: string;
  style?: CSSProperties;
  color?: string | null;
  onClick?: () => any;
  loading?: boolean;
  icon?: any;
  iconDirection?: "left" | "right"
  iconSpin?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: React.FC<React.PropsWithChildren<Props>> = ({
                                                                   label,
                                                                   color,
                                                                   icon,
                                                                   disabled,
                                                                   loading,
                                                                   style,
                                                                   className,
                                                                   onClick,
                                                                   children,
                                                                   iconSpin,
                                                                   iconDirection = "left",
                                                                   ...props
                                                                 }) => {
  return (
    <>
      <button
        {...props}
        disabled={disabled ?? false}
        type="button"
        className={twMerge(
          cn(
            "rounded-md border-gray-300 shadow-sm px-4 py-2 text-sm text-gray-700 font-medium",
            color,
            "disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 focus:outline-none",
            "dark:bg-neutral-800 dark:text-white dark:border-gray-500",
            className
          )
        )}
        style={{ ...(style ?? {}), borderWidth: "1px" }}
        onClick={onClick}
      >
        {iconDirection === "left" && !loading && icon && <>
          <FontAwesomeIcon icon={icon} spin={iconSpin} size={"1x"} />{" "}
        </>}

        {label && label}{" "}
        {loading && <FontAwesomeIcon icon={faArrowsSpin} size={"1x"} spin />}
        {iconDirection === "right" && !loading && icon && <>
          <FontAwesomeIcon icon={icon} spin={iconSpin} size={"1x"} />{" "}
        </>}
        {children}
      </button>
    </>
  );
};
